import { On3IconLockPremium } from '@on3/icons';
import { format } from 'date-fns';
import Link from 'next/link';
import { useMemo } from 'react';

import styles from './ValuesUpdated.module.scss';

interface IValuesUpdatedProps {
  lastUpdated?: string;
}
export const ValuesUpdated = ({ lastUpdated }: IValuesUpdatedProps) => {
  const formatUpdate = useMemo(() => {
    if (lastUpdated) {
      const updateDate = new Date(lastUpdated);
      const updateDay = format(updateDate, 'P');
      const updateTime = format(updateDate, 'pp');

      return `Last Updated on ${updateDay} at ${updateTime}`;
    }

    return null;
  }, [lastUpdated]);

  const joinLink = `/subscribe/`;

  const params = new URLSearchParams({
    utm_source: 'nil',
    utm_medium: 'web',
    utm_campaign: 'nil_valuations',
    utm_content: 'header_lock',
  });

  const utmLink = `${joinLink}?${params}`;

  return (
    <div className={styles.block}>
      <p>
        NIL Valuation and Roster Value are updated every Wednesday and are
        exclusive to{' '}
        <Link href={utmLink}>
          <On3IconLockPremium />
        </Link>{' '}
        subscribers
      </p>
      <Link
        className={styles.about}
        href="/nil/news/about-on3-nil-valuation-per-post-value/"
      >
        About NIL Valuations
      </Link>
      {formatUpdate && <div className={styles.update}>{formatUpdate}</div>}
    </div>
  );
};
